import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/symbol_white.png")